import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CallToActionProps {
  isAuthenticated: boolean;
}

const CallToAction = ({ isAuthenticated }: CallToActionProps) => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-cecure-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to Create Your Next Successful Event?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Join thousands of event organizers who trust CecureStream Events
              to deliver exceptional experiences for their attendees.
            </p>
            <div className="space-y-4 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row">
              <Button
                size="lg"
                className="bg-white text-cecure-900 hover:bg-blue-100"
                onClick={() => {
                  if (isAuthenticated) {
                    navigate("/create");
                  } else {
                    navigate("/signin");
                  }
                }}
              >
                Get Started Free
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              {/* <Button 
                size="lg"
                variant="outline" 
                className="border-white text-white hover:bg-white/10"
              >
                Schedule a Demo
              </Button> */}
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-cecure-800 p-6 rounded-lg border border-cecure-700">
              <h3 className="text-xl font-semibold text-white mb-3">
                Free Plan
              </h3>
              <ul className="space-y-2 text-blue-100 mb-4">
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Unlimited Free Physical Events
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Unlimited Attendee for Physical Events +2.5% charge on tickets for paid events
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
            Free Email for attendees
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Unlimited Video Conferencing for Virtual Events +5% charge on tickets for paid events
                </li> 
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Unlimited Free Virtual Events                </li>
                  <li className="flex items-start">
                    <span className="text-green-400 mr-2">✓</span>
                    Free Integrated HD Video Conferencing for Virtual Events
                  </li>
              </ul>
              <Button
                className="w-full bg-cecure-600 hover:bg-cecure-700"
                onClick={() => {
                  if (isAuthenticated) {
                    navigate("/create");
                  } else {
                    navigate("/signin");
                  }
                }}
              >
                Start for Free
              </Button>
            </div>

            {/* <div className="bg-cecure-800 p-6 rounded-lg border border-cecure-700 relative">
              <div className="absolute -top-3 right-4 bg-accent text-white text-xs px-3 py-1 rounded-full font-medium">
                POPULAR
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">
                Pro Plan
              </h3>
              <ul className="space-y-2 text-blue-100 mb-4">
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Unlimited events
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  1,000 attendees per event
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Custom registration forms
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Multiple ticket types
                </li>
                <li className="flex items-start">
                  <span className="text-green-400 mr-2">✓</span>
                  Advanced analytics
                </li>
              </ul>
              <Button
                className="w-full bg-accent hover:bg-blue-600"
                onClick={() => {
                  if (isAuthenticated) {
                    navigate("/billing");
                  } else {
                    navigate("/signin");
                  }
                }}
              >
                Get Started
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
